import React, { useEffect, useState } from 'react';
import { supabase } from '../../supabase';

const PartnerLogo = (props) => {
    const [logos, setLogos] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const getLogos = async () => {
            const { data, error } = await supabase
                .from('partners')
                .select('logo_url');

            if (!error && data) {
                const logoStrings = data
                    .map(item => item.logo_url)
                    .filter(url => url !== null); 
                
                setLogos(logoStrings);
            }
            setLoading(false);
        };

        getLogos();
    }, []); 

    if (loading) return null;

    return (
        <div className={props.className}>
            {logos.map((url, index) => (
                <img 
                    key={index} 
                    src={url} 
                    alt={`Partner ${index}`} 
                />
            ))}
        </div>
    );
}

export default PartnerLogo;